<p>configurations works!</p>
